import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getAreas = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/areas`, {
      params: {
        page: 1,
        pageSize: 25,
        sortField: 'id',
        sortOrder: 'DESC',
        ...params,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching areas:', error.response?.data || error);
    throw error;
  }
};

export const getAreaById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/areas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching area:', error.response?.data || error);
    throw error;
  }
};

export const getAreaByCode = async (code, excludeId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/areas/by-areaCode/${encodeURIComponent(code)}`,
      {        params: excludeId ? { excludeId } : {},
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching area by code:', error.response?.data || error);
    throw error;
  }
};

export const checkAreaDuplicate = async (areaCode, name, excludeId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/areas/check-duplicate`,
      {
        params: { code: areaCode, name, excludeId },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error checking area:', error.response?.data || error);
    throw error;
  }
};

export const createArea = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/areas`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating area:', error.response?.data || error);
    throw error;
  }
};

export const updateArea = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/areas/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating area:', error.response?.data || error);
    throw error;
  }
};

export const deleteArea = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/areas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting area:', error.response?.data || error);
    throw error;
  }
};
